export type Padding = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 24 | 32 | 44;

export type PaddingMap = {
  [key in Padding]: string;
};

export const paddingMap: PaddingMap = {
  /** 0px */
  0: "p-0",
  /** 4px */
  1: "p-1",
  /** 8px */
  2: "p-2",
  /** 12px */
  3: "p-3",
  /** 16px */
  4: "p-4",
  /** 20px */
  5: "p-5",
  /** 24px */
  6: "p-6",
  /** 28px */
  7: "p-7",
  /** 32px */
  8: "p-8",
  /** 36px */
  9: "p-9",
  /** 40px */
  10: "p-10",
  /** 48px */
  24: "p-24",
  /** 64px */
  32: "p-32",
  /** 176px */
  44: "p-44",
} as const;

export const paddingXMap: PaddingMap = {
  0: "px-0",
  1: "px-1",
  2: "px-2",
  3: "px-3",
  4: "px-4",
  5: "px-5",
  6: "px-6",
  7: "px-7",
  8: "px-8",
  9: "px-9",
  10: "px-10",
  24: "px-24",
  32: "px-32",
  44: "px-44",
} as const;

export const paddingYMap: PaddingMap = {
  0: "py-0",
  1: "py-1",
  2: "py-2",
  3: "py-3",
  4: "py-4",
  5: "py-5",
  6: "py-6",
  7: "py-7",
  8: "py-8",
  9: "py-9",
  10: "py-10",
  24: "py-24",
  32: "py-32",
  44: "py-44",
} as const;

export const paddingTopMap: PaddingMap = {
  0: "pt-0",
  1: "pt-1",
  2: "pt-2",
  3: "pt-3",
  4: "pt-4",
  5: "pt-5",
  6: "pt-6",
  7: "pt-7",
  8: "pt-8",
  9: "pt-9",
  10: "pt-10",
  24: "pt-24",
  32: "pt-32",
  44: "pt-44",
} as const;

export const paddingBottomMap: PaddingMap = {
  0: "pb-0",
  1: "pb-1",
  2: "pb-2",
  3: "pb-3",
  4: "pb-4",
  5: "pb-5",
  6: "pb-6",
  7: "pb-7",
  8: "pb-8",
  9: "pb-9",
  10: "pb-10",
  24: "pb-24",
  32: "pb-32",
  44: "pb-44",
} as const;

export const paddingLeftMap: PaddingMap = {
  0: "pl-0",
  1: "pl-1",
  2: "pl-2",
  3: "pl-3",
  4: "pl-4",
  5: "pl-5",
  6: "pl-6",
  7: "pl-7",
  8: "pl-8",
  9: "pl-9",
  10: "pl-10",
  24: "pl-24",
  32: "pl-32",
  44: "pl-44",
} as const;

export const paddingRightMap: PaddingMap = {
  0: "pr-0",
  1: "pr-1",
  2: "pr-2",
  3: "pr-3",
  4: "pr-4",
  5: "pr-5",
  6: "pr-6",
  7: "pr-7",
  8: "pr-8",
  9: "pr-9",
  10: "pr-10",
  24: "pr-24",
  32: "pr-32",
  44: "pr-44",
} as const;

export type Margin = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 24 | 32 | 44;

export type MarginMap = {
  [key in Margin]: string;
};

export const marginMap: MarginMap = {
  /** 0px */
  0: "m-0",
  /** 4px */
  1: "m-1",
  /** 8px */
  2: "m-2",
  /** 12px */
  3: "m-3",
  /** 16px */
  4: "m-4",
  /** 20px */
  5: "m-5",
  /** 24px */
  6: "m-6",
  /** 28px */
  7: "m-7",
  /** 32px */
  8: "m-8",
  /** 36px */
  9: "m-9",
  /** 40px */
  10: "m-10",
  /** 48px */
  24: "m-24",
  /** 64px */
  32: "m-32",
  /** 176px */
  44: "m-44",
} as const;

export const marginXMap: MarginMap = {
  0: "mx-0",
  1: "mx-1",
  2: "mx-2",
  3: "mx-3",
  4: "mx-4",
  5: "mx-5",
  6: "mx-6",
  7: "mx-7",
  8: "mx-8",
  9: "mx-9",
  10: "mx-10",
  24: "mx-24",
  32: "mx-32",
  44: "mx-44",
} as const;

export const marginYMap: MarginMap = {
  0: "my-0",
  1: "my-1",
  2: "my-2",
  3: "my-3",
  4: "my-4",
  5: "my-5",
  6: "my-6",
  7: "my-7",
  8: "my-8",
  9: "my-9",
  10: "my-10",
  24: "my-24",
  32: "my-32",
  44: "my-44",
} as const;

export const marginTopMap: MarginMap = {
  0: "mt-0",
  1: "mt-1",
  2: "mt-2",
  3: "mt-3",
  4: "mt-4",
  5: "mt-5",
  6: "mt-6",
  7: "mt-7",
  8: "mt-8",
  9: "mt-9",
  10: "mt-10",
  24: "mt-24",
  32: "mt-32",
  44: "mt-44",
} as const;

export const marginBottomMap: MarginMap = {
  0: "mb-0",
  1: "mb-1",
  2: "mb-2",
  3: "mb-3",
  4: "mb-4",
  5: "mb-5",
  6: "mb-6",
  7: "mb-7",
  8: "mb-8",
  9: "mb-9",
  10: "mb-10",
  24: "mb-24",
  32: "mb-32",
  44: "mb-44",
} as const;

export const marginLeftMap: MarginMap = {
  0: "ml-0",
  1: "ml-1",
  2: "ml-2",
  3: "ml-3",
  4: "ml-4",
  5: "ml-5",
  6: "ml-6",
  7: "ml-7",
  8: "ml-8",
  9: "ml-9",
  10: "ml-10",
  24: "ml-24",
  32: "ml-32",
  44: "ml-44",
} as const;

export const marginRightMap: MarginMap = {
  0: "mr-0",
  1: "mr-1",
  2: "mr-2",
  3: "mr-3",
  4: "mr-4",
  5: "mr-5",
  6: "mr-6",
  7: "mr-7",
  8: "mr-8",
  9: "mr-9",
  10: "mr-10",
  24: "mr-24",
  32: "mr-32",
  44: "mr-44",
} as const;